
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const NavbarBrand = () => {
  return (
    <Link to="/" className="flex items-center gap-2">
      <ShieldCheck className="h-6 w-6 text-fraudeye-accent" />
      <span className="text-xl font-bold bg-gradient-to-r from-fraudeye-accent to-fraudeye-highlight bg-clip-text text-transparent">
        FraudEye
      </span>
    </Link>
  );
};

export default NavbarBrand;
